// Rails CSRF token from the <meta name="csrf-token"> tag, for fetch/XHR mutating
// requests. Returns '' when absent so callers can always set the header.
export function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || '';
}
